
import Vue from "vue";
import { PropType } from "vue";
import { welcomeToTheMoonMixins } from "@/mixins/welcomeToTheMoonMixins";
import {
  WelcomeToTheMoonCampaign,
  WelcomeToTheMoonPlay,
  WelcomeToTheMoonPlayer,
} from "@/types";

export default Vue.extend({
  name: "WelcomeToTheMoonScoresByCampaign",
  mixins: [welcomeToTheMoonMixins],
  props: {
    campaigns: {
      type: Array as PropType<WelcomeToTheMoonCampaign[]>,
      required: true,
      default: [],
    },
    plays: {
      type: Array as PropType<WelcomeToTheMoonPlay[]>,
      required: true,
      default: [],
    },
    mainPlayerId: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    sortedPlays(): WelcomeToTheMoonPlay[] {
      return this.plays.slice(0).reverse();
    },
  },
  methods: {
    getPlayers(plays: WelcomeToTheMoonPlay[]): WelcomeToTheMoonPlayer[] {
      const players: WelcomeToTheMoonPlayer[] = [];
      plays.forEach((play) => {
        play.players.forEach((playerFromPlay: WelcomeToTheMoonPlayer) => {
          if (!players.find((player) => player.id === playerFromPlay.id)) {
            players.push(playerFromPlay);
          }
        });
      });
      return players;
    },
    getPlayerStats(
      playerId: number | undefined,
      plays: WelcomeToTheMoonPlay[]
    ): {
      stars: number;
      victories: number;
      scores: number[];
      automaLevels: number[];
    } {
      const stats = { stars: 0, victories: 0, scores: [0], automaLevels: [0] };
      stats.scores = [];
      stats.automaLevels = [];
      plays.forEach((play) => {
        const player = play.players.find(
          (playerFromPlay: WelcomeToTheMoonPlayer) =>
            playerFromPlay.id === playerId
        );
        if (!player) {
          return;
        }
        if (player.stars) {
          stats.stars += player.stars;
        }
        if (player.winner) {
          stats.victories++;
        }
        if (player.score) {
          stats.scores.push(player.score);
        }
        if (player.automa && player.automaLevel) {
          stats.automaLevels.push(player.automaLevel);
        }
      });
      return stats;
    },
  },
});
